import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface DeliveryAddress {
  city: string;
  street: string;
  house: string;
  apartment?: string;
  postalCode?: string;
}

export interface CheckoutFormData {
  name: string;
  phone: string;
  email: string;
  deliveryType: 'delivery' | 'pickup';
  address: DeliveryAddress;
  pickupPointId?: number;
  /** Не используется: дата и время доставки обязательны всегда */
  deliveryAsReady?: boolean;
  /** 'exact' = точное время (+400 ₽), 'night' = ночная (+500 ₽), 'approximate' = в районе 2 ч (без доплаты) */
  deliveryTimeType?: 'exact' | 'approximate' | 'night' | null;
  deliveryDate?: string;
  deliveryTime?: string;
  recipientName?: string;
  recipientPhone?: string;
  cardText?: string;
  comment: string;
  paymentType: 'card_requisites' | 'sbp_qr' | 'yandex_pay' | 'alfa_bank';
  useBonuses?: boolean;
  promocode?: string;
}

interface CheckoutStore {
  formData: CheckoutFormData | null;
  saveFormData: (data: CheckoutFormData) => void;
  clearFormData: () => void;
  /** Сохранённый заказ в процессе оплаты: при повторном открытии приложения вести на /checkout и шаг оплаты */
  pendingOrderId: number | null;
  pendingOrderNumber: string | null;
  pendingOrderTotal: number | null;
  /** Когда заказ был сохранён как pending (ms since epoch). Used to auto-unlock after deploy/hang. */
  pendingOrderCreatedAt: number | null;
  paymentStep: 'form' | 'payment';
  setPendingOrder: (orderId: number, orderNumber: string, orderTotal: number, step: 'form' | 'payment') => void;
  clearPendingOrder: () => void;
}

export const useCheckoutStore = create<CheckoutStore>()(
  persist(
    (set) => ({
      formData: null,
      pendingOrderId: null,
      pendingOrderNumber: null,
      pendingOrderTotal: null,
      pendingOrderCreatedAt: null,
      paymentStep: 'form',

      saveFormData: (data) => {
        set({ formData: data });
      },

      clearFormData: () => {
        set({ formData: null });
      },

      setPendingOrder: (orderId, orderNumber, orderTotal, step) => {
        set({
          pendingOrderId: orderId,
          pendingOrderNumber: orderNumber,
          pendingOrderTotal: orderTotal,
          pendingOrderCreatedAt: Date.now(),
          paymentStep: step,
        });
      },

      clearPendingOrder: () => {
        set({
          pendingOrderId: null,
          pendingOrderNumber: null,
          pendingOrderTotal: null,
          pendingOrderCreatedAt: null,
          paymentStep: 'form',
        });
      },
    }),
    {
      name: 'checkout-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
